































import moment from "moment/moment";
import Component, { mixins } from "vue-class-component";
import CoffreMixin from "@/mixins/coffreUtils";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class ListExports extends mixins(CoffreMixin, ErrorMixin) {
  public datePick: any = new Date().toISOString().substr(0, 10);
  public coffres = new Array();
  public loadData = false;
  public search = "";
  public headers = [
    { text: "Libelle", value: "libelle", class: "data-head" },
    { text: "Solde", value: "solde", class: "data-head" },
  ];

  public mounted() {
    this.getCoffres();
  }

  public getCoffres() {
    this.loadData = true;
    this.$store.dispatch("analyses/getCoffre", this.datePick).then(
      (response: any) => {
        this.coffres = response.response.filter((item: any) => {
          return item.tag.includes("count=true");
        });
        this.loadData = false;
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
        // this.$store.dispatch("login/setLoading", false);
      }
    );
  }

  public formatDateTicket(horodatage: number) {
    const d = moment(horodatage).format("DD/MM/YYYY");
    return d;
  }
}
